import { useState } from "react";

export type Currency = "NGN" | "USD";

const STORAGE_KEY = "admin_currency";

// Currency choice, remembered across pages and reloads.
const useCurrency = () => {
  const [currency, setCurrency] = useState<Currency>(() =>
    localStorage.getItem(STORAGE_KEY) === "USD" ? "USD" : "NGN"
  );

  const updateCurrency = (value: Currency) => {
    localStorage.setItem(STORAGE_KEY, value);
    setCurrency(value);
  };

  return [currency, updateCurrency] as const;
};

export default useCurrency;
